import {
  AccessCode,
  AccessCodeDropdownItem,
  AccessCodeInOrganization,
  BaseAccessCode,
  BaseTableRequest,
  Response,
  TableResponse,
  UpdateAccessCodeWithManagersRequest,
} from 'types'
import axiosInstance from './axios'

export const getCodes = async (request: BaseTableRequest): Promise<TableResponse<AccessCode>> => {
  return axiosInstance.post('/access-codes', request)
}

export const createCode = async (request: BaseAccessCode): Promise<Response<AccessCode>> => {
  return axiosInstance.post('/access-codes/create', request)
}

export const saveDraftCode = async (
  request: Partial<AccessCode>,
): Promise<Response<AccessCode>> => {
  return axiosInstance.post('/access-codes/save-draft', request)
}

export const updateCode = async (request: BaseAccessCode): Promise<Response<AccessCode>> => {
  return axiosInstance.post('/access-codes/update', request)
}

export const getCodesDropdown = async (): Promise<Response<AccessCodeDropdownItem[]>> => {
  return axiosInstance.post('/access-codes/dropdown')
}

export const getAccessCodesWithManagers = async (request: {
  organizationId: number
}): Promise<Response<AccessCodeInOrganization[]>> => {
  return axiosInstance.post('/access-codes/with-managers', request)
}

export const updateAccessCodesWithManagers = async (
  request: UpdateAccessCodeWithManagersRequest,
): Promise<Response<AccessCodeInOrganization[]>> => {
  return axiosInstance.post('/access-codes/update-managers', request)
}
